// src/components/ConfirmDialog.tsx
import React from "react";
import { MdClose } from "react-icons/md";

type Props = {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
};
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmText = "Sí, continuar",
  cancelText = "Cancelar",
  onConfirm,
  onCancel,
}: Props) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
      <div className="absolute left-1/2 top-1/2 w-[min(92vw,480px)] -translate-x-1/2 -translate-y-1/2 rounded-xl border border-surface bg-surface p-4 shadow-xl">
        <div className="mb-2 flex items-center justify-between">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button
            className="btn btn-outline"
            onClick={onCancel}
            aria-label="Cerrar"
          >
            <MdClose />
          </button>
        </div>
        <p className="mb-4 text-sm text-on-surface/80">{message}</p>
        <div className="flex justify-end gap-2">
          <button className="btn btn-outline" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="btn btn-primary" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
